import { get, isEmpty } from 'lodash-es';
import { getCurrentDate } from 'site-modules/shared/utils/date-utils';

/**
 * Determines if the offer is expired.
 * @param {Object} offerDetails
 *    @param {String} expiresDisplayDate
 * @returns {Boolean}
 */
export const isExpiredOffer = offerDetails => {
  if (isEmpty(offerDetails)) {
    return false;
  }

  let expirationDate;
  const expiresDateUtc = get(offerDetails, 'expiresDateUtc');

  if (expiresDateUtc) {
    expirationDate = new Date(expiresDateUtc);
  } else {
    expirationDate = new Date(get(offerDetails, 'expiresDisplayDate'));
    expirationDate.setDate(expirationDate.getDate() + 1);
  }

  return getCurrentDate() > expirationDate;
};

export const getBrandContactPhoneNumber = offer => offer?.brandAssets?.brandContact?.phone;
